import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=b2813ff0&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=b2813ff0&prod&lang=scss&scoped=true"
import style1 from "./footer.vue?vue&type=style&index=1&id=b2813ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2813ff0",
  null
  
)

export default component.exports